{
  "DATA_ASSISTANT": {
    "TITLE": "Data Asistent",
    "NEW_CONVERSATION": "+ Nový",
    "LOADING": "Načítavam...",
    "LOADING_MESSAGES": "Načítavam správy...",
    "THINKING": "Premýšľam...",
    "UNTITLED": "Nepomenovaná konverzácia",
    "NO_CONVERSATIONS": "Zatiaľ žiadne konverzácie. Kliknite na \"+ Nový\" pre začatie.",
    "EMPTY_STATE": "Vyberte konverzáciu alebo vytvorte novú.",
    "SEND": "Odoslať",
    "PLACEHOLDER": "Čo pre vás môžem zistiť?",
    "SHOW_SQL": "Zobraziť SQL",
    "NO_ROWS": "Žiadne výsledky.",
    "DELETE": "\u00d7",
    "DELETE_CONFIRM": "Zmazať konverzáciu",
    "DELETE_CONFIRM_DESCRIPTION": "Naozaj chcete zmazať túto konverzáciu? Túto akciu nie je možné vrátiť späť.",
    "DELETE_CONFIRM_YES": "Zmazať",
    "CHAT": "Chat",
    "REPORTS": "Reporty",
    "SAVE_TO_REPORT": "Uložiť do reportu",
    "NEW_REPORT": "Nový report",
    "REPORT_NAME": "Názov reportu",
    "NO_REPORTS": "Zatiaľ žiadne reporty",
    "REPORTS_EMPTY_STATE": "Vyberte report alebo vytvorte nový.",
    "REPORT_SAVED": "Uložené do reportu",
    "DELETE_REPORT_CONFIRM": "Zmazať report",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Naozaj chcete zmazať tento report? Všetky uložené položky budú odstránené.",
    "DELETE_ITEM_CONFIRM": "Odstrániť položku",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Naozaj chcete odstrániť túto položku z reportu?",
    "DELETE_ITEM_CONFIRM": "Odobrať položku",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Naozaj chcete odobrať túto položku z reportu?",
    "EXPORT_CSV": "Stiahnuť CSV",
    "REFRESH": "Obnoviť",
    "QUERY_RUNNING": "Spúšťam dopyt...",
    "QUERY_FAILED": "Dopyt zlyhal",
    "AUTO_REFRESH": "Automatické obnovenie",
    "AUTO_REFRESH_NONE": "Ručne",
    "AUTO_REFRESH_30S": "30 sekúnd",
    "AUTO_REFRESH_1M": "1 minúta",
    "AUTO_REFRESH_5M": "5 minút",
    "AUTO_REFRESH_10M": "10 minút",
    "EDIT_MESSAGE": "Upraviť správu",
    "RENAME_REPORT": "Premenovať report",
    "RENAME_ITEM": "Premenovať položku",
    "MOVE_UP": "Presunúť nahor",
    "MOVE_DOWN": "Presunúť nadol",
    "COLLABORATORS": {
      "BUTTON": "Spolupracovníci",
      "TITLE": "Spolupracovníci reportu",
      "DESCRIPTION": "Vyberte, ktorí agenti a tímy majú prístup k tomuto reportu.",
      "AGENTS": "Agenti",
      "TEAMS": "Tímy",
      "SELECT_AGENTS": "Vyberte agentov",
      "SELECT_TEAMS": "Vyberte tímy",
      "SAVE": "Uložiť",
      "SAVED": "Spolupracovníci aktualizovaní",
      "SAVE_FAILED": "Uloženie spolupracovníkov zlyhalo"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Reporty"
}
